import { render } from "./DynamicAuthLayout.vue?vue&type=template&id=a9c53ada"
import script from "./DynamicAuthLayout.vue?vue&type=script&lang=js"
export * from "./DynamicAuthLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__